import React, { useState } from 'react'
import { Responsive } from 'semantic-ui-react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { firebaseConnect } from 'react-redux-firebase'
import MyMenu from './components/Menu/Menu'
import Nav from './components/Nav/Nav'
import SideBarCart from '../../Cart/SideBarCart'
const NavBar = ({ location, auth, firebase, ...props }) => {
  const [opened, setOpened] = useState(false)
  const [index, setIndex] = useState(props.history.location.pathname === '/')
  const [visibleSearch, setVisibleSearch] = useState(false)
  const [nProducts, setNProducts] = useState(0)

  const isActive = (route) => route === location.pathname
  const myLocation = location.pathname

  const handleLogout = async () => {
    try {
      await firebase.auth().signOut()
      await localStorage.clear()
    } catch (error) {}
  }
  return (
    <div>
      <Responsive maxWidth={750}>
        <MyMenu
          setVisibleSearch={setVisibleSearch}
          handleLogout={handleLogout}
          auth={auth}
          visibleSearch={visibleSearch}
          opened={opened}
          setOpened={setOpened}
          nofications={nProducts}
          index={false}
          setIndex={setIndex}
          categories={props.categories}
          menu={true}
        />
      </Responsive>
      <SideBarCart
        opened={opened}
        setOpened={setOpened}
        nProducts={nProducts}
        setNProducts={setNProducts}
      />
      <Responsive minWidth={750}>
        <Nav
          auth={auth}
          index={index}
          setIndex={setIndex}
          isActive={isActive}
          opened={opened}
          setOpened={setOpened}
          handleLogout={handleLogout}
          visibleSearch={visibleSearch}
          setVisibleSearch={setVisibleSearch}
          nofications={nProducts}
          categories={props.categories}
          myLocation={myLocation}
        />
      </Responsive>
    </div>
  )
}

const mapStateToProps = ({ firebase: { auth, profile } }) => ({
  auth,
  profile,
})

export default compose(
  withRouter,
  firebaseConnect(),
  connect(mapStateToProps, null)
)(NavBar)
